<template lang="html">
  <div class="w-full max-w-(--ui-container) px-4 py-8 sm:m-auto sm:py-10">
    <h1 class="mb-6 text-2xl font-bold">
      {{ title }}
    </h1>

    <div class="rounded-none border border-default p-4 text-sm leading-6 text-toned sm:p-6">
      <slot />

      <LegalDocumentSourceDownload
        v-if="sourceKey"
        :href="getLegalDocumentSourceUrl(sourceKey)"
        :filename="legalDocumentSources[sourceKey]"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import LegalDocumentSourceDownload from './LegalDocumentSourceDownload.vue'

import {
  getLegalDocumentSourceUrl,
  legalDocumentSources,
  type LegalDocumentSourceKey,
} from '#Info/constants/legalDocuments'

defineProps<{
  title: string
  sourceKey?: LegalDocumentSourceKey
}>()
</script>
